import { render, staticRenderFns } from "./ManagerMenu.vue?vue&type=template&id=60ef7d3e&scoped=true&"
import script from "./ManagerMenu.vue?vue&type=script&lang=js&"
export * from "./ManagerMenu.vue?vue&type=script&lang=js&"
import style0 from "./ManagerMenu.vue?vue&type=style&index=0&id=60ef7d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ef7d3e",
  null
  
)

export default component.exports